import { CourtSystemRepository } from '@ftr/contracts/court-uploader'

export class SetRepositoryAction {
  static readonly type = '[CourtUploader] Set Repository'

  constructor(public repository: CourtSystemRepository) {}
}
